export const bookingStateTranslations = {
  BOOKED: 'bookings:common.state.booked',
  STARTED: 'bookings:common.state.started',
  FINISHED: 'bookings:common.state.finished',
  CANCELED: 'bookings:common.state.cancelled',
} as const;
